<wlm-account-card-layout class="account-card-items">
  <button mat-menu-item (click)="navigatetoUserPage()">
    <span>{{ T_SCOPE + '.personal-info' | translate }}</span>
    <mat-icon>perm_identity</mat-icon>
  </button>

  <button mat-menu-item (click)="openVersionPopup()">
    <span>{{ T_SCOPE + '.version-info' | translate }}</span>
    <mat-icon class="material-icons-outlined">info</mat-icon>
  </button>

  <button mat-menu-item (click)="cleanCache()">
    <span>{{ T_SCOPE + '.clean-cache' | translate }}</span>
    <mat-icon>cached</mat-icon>
  </button>

  <button mat-menu-item class="menu-option-slider" (click)="toggleDarkTheme()">
    <span>{{ T_SCOPE + '.dark-theme' | translate }}</span>
    <mat-slide-toggle color="primary" [checked]="darkThemeSliderChecked"></mat-slide-toggle>
  </button>

  <button mat-menu-item (click)="logOut()">
    <span>{{ T_SCOPE + '.sign-out' | translate }}</span>
    <mat-icon>exit_to_app</mat-icon>
  </button>
</wlm-account-card-layout>
